import React from "react";
import ProjectLayout from "../components/ProjectLayout";
import heroImage from "../../../assets/Images/project/project-banner.png";

const Transportation = () => {
  return (
    <ProjectLayout
      heroImage={heroImage}
      title="Surveying - Transportation Projects"
      subtitle="Railway/Metro /Expressway/Highway/Mega highway/MDR Roads/ PMGSY Roads - More than 1500.0 KM."
      sector="SURVEYING"
      subCategory="TRANSPORTATION"
    />
  );
};

export default Transportation;
